module.exports = __webpack_public_path__ + "img/scence1.7e6e3ab5.jpg";